import PropTypes from 'prop-types';
import React from 'react';

const Input = ({data, onChange, value}) => {
  const error = data.errorMessage ? (
    <div className="alert alert-danger">
      {data.errorMessage}
    </div>
  ) : null;
  return (
    <div className="form-group col-xs-8 col-xxs-16">
      <label className="control-label floating-label" htmlFor={data.name}>{data.placeholder}</label>
      <input
        autoComplete={data.autoComplete}
        required={!!data.required}
        onChange={onChange}
        className="form-control"
        type={data.type}
        name={data.name}
        value={value}
      />
      {error}
    </div>
  );
};

Input.propTypes = {
  data: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
};

export default Input;


// WEBPACK FOOTER //
// ./src/components/contact/input.js